// eslint-disable-next-line import/default
import queryString from 'query-string';

export const getQueryParam = (
  key: string,
  search: string = window.location.search
): string | null | undefined => {
  const parsed = queryString.parse(search);
  let match = parsed[key];
  if (Array.isArray(match)) {
    match = match[0];
  }

  return match;
};
